/**
 * Clamp a per-frame delta (seconds) so a GLB-load / GC / tab-out spike can
 * never push a multi-frame movement or physics step in one tick. Applied at
 * the single dt source in BaseLevel so every downstream consumer inherits it.
 */
export function clampDeltaTime(rawSeconds: number, maxSeconds = 0.05): number {
  if (!Number.isFinite(rawSeconds) || rawSeconds <= 0) return 0;
  return Math.min(rawSeconds, maxSeconds);
}
